export function header() {
	document.addEventListener('DOMContentLoaded', function () {
		gsap.config({ nullTargetWarn: false });

		const header = document.querySelector('.js-header');
		const mv = document.querySelector('.js-mv');
		const webLink = document.querySelector('.js-web-link');
		const overlay = document.querySelector('.js-overlay');
		const tabLists = document.querySelector('.p-top-pickup__tab-lists');

		// if (header && mv) {
		//     const mvHeight = mv.offsetHeight;

		//     window.addEventListener('scroll', function () {
		//         if (window.scrollY > mvHeight) {
		//             header.classList.add('change-color');
		//         } else {
		//             header.classList.remove('change-color');
		//         }
		//     });
		// }

		document.querySelectorAll('.js-hamburger').forEach(function (hamburger) {
			hamburger.addEventListener('click', function () {
				this.classList.toggle('is-open');
				const drawer = document.querySelector('.js-drawer');
				if (drawer.classList.contains('is-open')) {
					closeDrawer();
				} else {
					openDrawer();
				}
			});
		});

		document.querySelectorAll('.p-header__nav-item a').forEach(function (link) {
			link.addEventListener('click', function () {
				if (document.querySelector('.js-hamburger').classList.contains('is-open')) {
					closeDrawer();
				}
			});
		});

		document.querySelectorAll('.js-drawer a[href]').forEach(function (link) {
			link.addEventListener('click', function () {
				closeDrawer();
			});
		});

		if (overlay) {
			overlay.addEventListener('click', function () {
				closeDrawer();
			});
		}

		window.addEventListener('resize', function () {
			if (window.matchMedia('(min-width: 768px)').matches) {
				closeDrawer();
			}
		});

		function openDrawer() {
			const drawer = document.querySelector('.js-drawer');
			drawer.classList.add('is-open');
			document.body.classList.add('body-no-scroll');
			if (overlay) {
				overlay.classList.add('is-active');
			}
			if (tabLists) {
				tabLists.classList.add('z-index-reduced');
			}
		}

		function closeDrawer() {
			const drawer = document.querySelector('.js-drawer');
			const hamburger = document.querySelector('.js-hamburger');
			drawer.classList.remove('is-open');
			hamburger.classList.remove('is-open');
			document.body.classList.remove('body-no-scroll');
			if (overlay) {
				overlay.classList.remove('is-active');
			}
			if (tabLists) {
				tabLists.classList.remove('z-index-reduced');
			}
		}
	});
}
